import { useEffect, useState } from "react"
import * as S from "./styles"
import texts from "../../_lang"
import { PatternsNames } from "../../utils/types/template"

import Template from "../../components/_template"
import LoadingDots from "../../components/LoadingDots"

import { ReactComponent as CameraIcon } from "../../assets/icons/camera.svg"
import { ReactComponent as CameraDenIcon } from "../../assets/icons/camera_denied.svg"
import { ReactComponent as UploadIcon } from "../../assets/icons/upload.svg"
import { ReactComponent as AlertIcon } from "../../assets/icons/alert.svg"
import Button from "../../components/Button"
import { ApiErrorMessage } from "../../utils/types/api/SendPhoto"

type Props = {
  isError: boolean
  msgType:
    | "leadingCamera"
    | "cameraDenied"
    | "uploading"
    | "unknown"
    | "sendError"
    | "faceInvalid"
  startFlow?: () => void
  apiError?: ApiErrorMessage | null
}

function FeedBackPage(p: Props) {
  const [icon, setIcon] = useState<JSX.Element | null>(null)
  const [combination, setCombination] = useState<PatternsNames>("greenPurple")

  useEffect(() => {
    switch (p.msgType) {
      case "leadingCamera":
        setIcon(<CameraIcon />)
        setCombination("greenPurple")
        break
      case "cameraDenied":
        setIcon(<CameraDenIcon />)
        setCombination("purpleGreen")
        break
      case "uploading":
        setIcon(<UploadIcon />)
        setCombination("greyGrey")
        break
      case "unknown":
        setIcon(<AlertIcon />)
        setCombination("darkGrey")
        break
      case "sendError":
      case "faceInvalid":
        setIcon(<AlertIcon />)
        setCombination("darkGrey")
        break
    }
  }, [p.isError && p.msgType])

  const shouldHaveButton = (() =>
    p.msgType !== "uploading" && p.msgType !== "leadingCamera")()

  const description =
    p.apiError?.title || texts.feedbacks[p.msgType].description
  const instructions =
    p.apiError?.message || texts.feedbacks[p.msgType].instructions

  return (
    <Template type={combination}>
      <S.Content>
        <S.Main>
          <S.Info>
            <S.IconArea>{icon}</S.IconArea>

            <S.Description>{description}</S.Description>
            {instructions.trim().length > 0 && (
              <S.Instructions>{instructions}</S.Instructions>
            )}
          </S.Info>
          {!p.isError && <LoadingDots />}
        </S.Main>
      </S.Content>
      {shouldHaveButton && (
        <div
          style={{
            position: "absolute",
            bottom: 60,
            display: "flex",
            justifyContent: "center",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Button.Primary
            noIcon={true}
            text={texts.other.buttons.retry}
            action={p.startFlow as () => void}
          />
        </div>
      )}
    </Template>
  )
}

export default FeedBackPage
